import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

//components
import HeaderApp from './components/HeaderApp';
import FooterApp from './components/FooterApp';

//Pages
import InicioPage from './pages/inicio';
import OShoppingPage from './pages/oshopping';
import LojasPage from './pages/lojas';
import VerLojaPage from './pages/lojas/ver';
import ServicosPage from './pages/servicos';
import EventosPage from './pages/eventos';
import VerEventoPage from './pages/eventos/ver';
import FaleConoscoPage from './pages/contato';
import BuscaPage from './pages/busca';
import NotFoundPage from './pages/404';
import PetFriendlyPage from './pages/petfriendly';
import CinemaPage from './pages/cinema';
import FilmeCinemaPage from './pages/cinema/filme';
import VerPromocaoPage from './pages/promocoes/promocao';

//services
import BuscaAPI from '../services/api/Busca';

class App extends React.Component {
	state = {
		lista_busca:[],
		loading_busca: true,
	}
	submitSearch = (busca) => {
		const form = {
			busca: busca,
		}
		BuscaAPI.lista(form)
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({
					lista_busca: res,
					loading_busca: false,
				})
				return;
			})
		});
	}

    render() {
		const { informacoes } = this.props;
		const { lista_busca, loading_busca } = this.state;
        return (
				<div>
					<HeaderApp informacoes={informacoes} submitSearch={this.submitSearch} />
					<div className="app_content" >
						<Switch>
							<Route exact path="/" component={() => <InicioPage informacoes={informacoes} />} />
							<Route exact path="/inicio" component={() => <InicioPage informacoes={informacoes} />} />
							<Route exact path="/o-shopping" component={OShoppingPage} />
							<Route exact path="/lojas" component={LojasPage} />
							<Route exact path="/lojas/:id" component={VerLojaPage} />
							<Route exact path="/servicos" component={ServicosPage} />
							<Route exact path="/eventos" component={EventosPage} />
							<Route exact path="/eventos/:id" component={VerEventoPage} />
							{/* <Route exact path="/promocoes" component={EventosPage} /> */}
							<Route exact path="/promocoes/:id" component={VerPromocaoPage} />
							<Route exact path="/fale-conosco" component={props => <FaleConoscoPage informacoes={informacoes} {...props} />} />
							<Route exact path="/busca" component={props => <BuscaPage lista={lista_busca}
																					  loading={loading_busca}
																					  submitSearch={this.submitSearch}
																					  {...props} />} />
							<Route exact path="/404" component={NotFoundPage}/ >
							<Route exact path="/pet-friendly" component={PetFriendlyPage}/ >
							<Route exact path="/cinema" component={CinemaPage}/ >
							<Route exact path="/cinema/filme/:id" component={FilmeCinemaPage}/ >

							<Redirect from="*" to="/404" />
						</Switch>
					</div>
					<FooterApp informacoes={informacoes} />
				</div>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/web/App.js